import nxModule from 'nxModule';

const templateUrl = require('./gl-header.template.html');
nxModule.component('glHeader', {
  templateUrl,
  transclude: true
});
